<mbs-form-group [formGroup]="formGroup"
                *ngIf="!hidden"
                class="mb-0 text-sm">

  <mbs-alert [type]="MbsPopupType.info"
             [icon]="true">
    {{ 'exportToPST.alert.consideredRestoreJob_1' | i18next: { format: 'capitalize' } }} <br />
    {{ 'exportToPST.alert.consideredRestoreJob_2' | i18next: { format: 'capitalize' } }}
  </mbs-alert>

  <!-- Mail -->
  <app-mail-filter [formGroup]="mailFormGroup"
                   [currentDay]="currentDay"
                   formGroupName="mail"
                   (isMailFilterChange)="mailFilterChange($event)" ></app-mail-filter>
  <!-- / Mail -->

  <!-- Contacts -->
  <ng-container formGroupName="contacts">
    <mbs-checkbox formControlName="checked"
                  [label]="'exportToPST.label.contacts' | i18next: { format: 'title' }"
                  [id]="'export-contacts'"></mbs-checkbox>
  </ng-container>
  <!-- / Contacts -->

  <!-- Calendar -->
  <ng-container formGroupName="calendar">
    <mbs-checkbox formControlName="checked"
                  [label]="'exportToPST.label.calendar' | i18next: { format: 'title' }"
                  [id]="'export-calendar'">
    </mbs-checkbox>
  </ng-container>
  <!-- / Calendar -->

</mbs-form-group>
